import { useSelector } from 'react-redux';
import { selectDocsFormData } from '../../redux-state/selectors';
import { TRANSACTION_TYPE_MAP } from '../docs/constants';
import { formatDate } from '../utility/formatDate';

function TransactionInformation() {
  const docsFormData = useSelector(selectDocsFormData)

  return (
    <div>
      <div className='border-t-2 border-t-gray-100 mb-3'>
        <div className='text-gray-700 mt-6 font-bold'>
          Transaction Information
        </div>
      </div>

      <div className='flex flex-col lg:flex-row w-full gap-6 lg:gap-8 mb-6'>
        <div className='flex flex-col w-full min-w-0 text-gray-700 gap-2'>
          {TRANSACTION_TYPE_MAP?.[docsFormData?.transactionType] && (
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Transaction Type:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {TRANSACTION_TYPE_MAP[docsFormData.transactionType]}
              </div>
            </div>
          )}

          {docsFormData?.transactionDate && (
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>Transaction Date:</div>
              <div className='font-medium text-right break-words min-w-0'>
                {formatDate(docsFormData.transactionDate)}
              </div>
            </div>
          )}

          <div className='flex flex-row justify-between gap-2 items-start'>
            <div>
              Military:
            </div>
            <div className='font-medium text-right break-words min-w-0'>
              {docsFormData?.military ? "Yes": "No"}
            </div>
          </div>

          {docsFormData?.plateNumber &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Plate Number:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {docsFormData?.plateNumber}
              </div>
            </div>
          }

          {docsFormData?.docsFees &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Doc Fees:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {Number(docsFormData?.docsFees || 0).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </div>
            </div>
          }

          {docsFormData?.insurancePackages &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Insurance Packages:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {Number(docsFormData?.insurancePackages || 0).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </div>
            </div>
          }

          {docsFormData?.protectionPackages &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Theft Protection:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {Number(docsFormData?.protectionPackages || 0).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </div>
            </div>
          }

          <div className='flex flex-row justify-between gap-2 items-start'>
            <div>
              Plate Transfer:
            </div>
            <div className='font-medium text-right break-words min-w-0'>
              {docsFormData?.plateTransfer ? 'Yes' : 'No'}
            </div>
          </div>

        </div>


        <div className='flex flex-col w-full min-w-0 text-gray-700 gap-2'>
          {docsFormData?.lien &&
            <div className='flex flex-row justify-between gap-2 items-start'>
            <div>
              Lien:
            </div>
            <div className='font-medium text-right break-words min-w-0'>
              {docsFormData?.lien ? "Yes": "No"}
            </div>
          </div>
          }

          {docsFormData?.uploadDate && (
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>Uploaded Date:</div>
              <div className='font-medium text-right break-words min-w-0'>
                {formatDate(docsFormData.uploadDate)}
              </div>
            </div>
          )}

          {docsFormData?.driverCategory &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
               Driver Category:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {docsFormData?.driverCategory}
              </div>
            </div>
          }

          {docsFormData?.basePrice &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Base Price:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {Number(docsFormData?.basePrice || 0).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </div>
            </div>
          }

          

          {docsFormData?.additionalFees &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Additional Fee:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {Number(docsFormData?.additionalFees || 0).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </div>
            </div>
          }

          {docsFormData?.protectionPackages &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Protection Packages:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {Number(docsFormData?.protectionPackages || 0).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </div>
            </div>
          }

          {docsFormData?.extendedWarranties &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Extended Warranties:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {Number(docsFormData?.extendedWarranties || 0).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </div>
            </div>
          }
          
        </div>
      </div>
    </div>
  )
}

export default TransactionInformation